const COMPANION_API_URL = process.env.REACT_APP_COMPANION_API_URL;

export async function getPublicPlatformControls() {
  if (!COMPANION_API_URL) return [];
  try {
    const res = await fetch(`${COMPANION_API_URL}/api/platform-controls/public`);
    if (!res.ok) return [];
    const data = await res.json().catch(() => ({}));
    return data.controls || [];
  } catch {
    return [];
  }
}

export async function getBlockingControl(key) {
  try {
    const controls = await getPublicPlatformControls();
    return controls.find((control) => control.key === key && control.enabled) || null;
  } catch {
    // Fail open when cp-companion is unreachable — core booking flows must continue.
    return null;
  }
}

export function platformControlMessage(control, fallback) {
  return control?.publicMessage || fallback || 'This action is temporarily unavailable. Please try again later.';
}
